const HiddenCard = ({ index, botId }) => <span className="bot-mini-card is-hidden" data-testid={`${botId}-hidden-card-${index}`}>W</span>;


export const BotSeat = ({ opponent, seat }) => {
  const revealed = Boolean(opponent?.cards?.length);
  return (
    <div className={`bot-seat bot-seat-${seat} ${opponent?.winner ? "is-winner" : ""}`} data-testid={`bot-seat-${seat}`}>
      <div className="bot-seat-name"><span>{opponent?.name}</span><small>{opponent?.winner ? "WINNER" : revealed ? opponent.hand_name : opponent?.style}</small></div>
      <div className="bot-hand" data-testid={`bot-hand-${seat}`}>
        {revealed
          ? opponent.cards.map((card, index) => <span key={`${card.code}-${index}`} className={`bot-mini-card ${card.color === "red" ? "is-red" : ""}`} data-testid={`bot-${seat}-card-${index}`}><b>{card.rank}</b>{card.suit}</span>)
          : [0, 1, 2, 3, 4].map((index) => <HiddenCard index={index} botId={`bot-${seat}`} key={index} />)}
      </div>
      <div className="bot-seat-status" data-testid={`bot-status-${seat}`}>{revealed ? `${opponent.draw_count} drawn` : "Thinking…"}</div>
    </div>
  );
};